import Icon from "react-svg-inline";

import addArchive from "./svg/addArchive.svg";
import addCustomization from "./svg/addCustomization.svg";
import addDomain from "./svg/addDomain.svg";
import addDomainAlias from "./svg/addDomainAlias.svg";
import addEmailAccount from "./svg/addEmalAccount.svg";
import addEmailAlias from "./svg/addEmailAlias.svg";
import addImport from "./svg/addImport.svg";
import addManager from "./svg/addManager.svg";
import addMigration from "./svg/addMigration.svg";
import addTeamMember from "./svg/addTeamMember.svg";
import addSuppressionList from "./svg/addSuppressionList.svg";
import adminColor from "./svg/adminColor.svg";
import aliasMailColor from "./svg/aliasMailColor.svg";
import appleStore from "./svg/appleStore.svg";
import archive from "./svg/archive.svg";
import archiveColor from "./svg/archiveColor.svg";
import arrowDown from "./svg/arrowDown.svg";
import arrowLeft from "./svg/arrowLeft.svg";
import arrowRight from "./svg/arrowRight.svg";
import arrowSort from "./svg/arrowSort.svg";
import arrowSortDown from "./svg/arrowSortDown.svg";
import arrowSortUp from "./svg/arrowSortUp.svg";
import arrowSwapColor from "./svg/arrowSwapColor.svg";
import arrowUp from "./svg/arrowUp.svg";
import attach from "./svg/attach.svg";
import attention from "./svg/attention.svg";
import back from "./svg/back.svg";
import calendar from "./svg/calendar.svg";
import cartColor from "./svg/cartColor.svg";
import check from "./svg/check.svg";
import check2 from "./svg/check2.svg";
import checkFatFill from "./svg/checkFatFill.svg";
import closeCircle from "./svg/closeCircle.svg";
import congratulations from "./svg/congratulations.svg";
import creationArchive from "./svg/creationArchive.svg";
import creationDelegate from "./svg/creationDelegate.svg";
import customizationsColor from "./svg/customizationsColor.svg";
import dashboardColor from "./svg/dashboardColor.svg";
import delegate from "./svg/delegate.svg";
import delegateColor from "./svg/delegateColor.svg";
import disable from "./svg/disable.svg";
import disabled from "./svg/disabled.svg";
import disabledAccount from "./svg/disabledAccount.svg";
import disabledArchive from "./svg/disabledArchive.svg";
import disabledDomain from "./svg/disabledDomain.svg";
import docs from "./svg/docs.svg";
import edit from "./svg/edit.svg";
import enable from "./svg/enable.svg";
import errorFill from "./svg/errorFill.svg";
import etliveColor from "./svg/etliveColor.svg";
import file from "./svg/file.svg";
import flag from "./svg/flag.svg";
import globe from "./svg/globe.svg";
import globeColor from "./svg/globeColor.svg";
import googlePlayStore from "./svg/googlePlayStore.svg";
import help from "./svg/help.svg";
import helpFill from "./svg/helpFill.svg";
import imports from "./svg/imports.svg";
import importsColor from "./svg/importsColor.svg";
import infoFill from "./svg/infoFill.svg";
import less from "./svg/less.svg";
import lock from "./svg/lock.svg";
import loginIllustration from "./svg/loginIllustration.svg";
import logoutColor from "./svg/logoutColor.svg";
import mail from "./svg/mail.svg";
import mailColor from "./svg/mailColor.svg";
import manager from "./svg/manager.svg";
import managerColor from "./svg/managerColor.svg";
import menu from "./svg/menu.svg";
import migrations from "./svg/migrations.svg";
import migrationsColor from "./svg/migrationsColor.svg";
import more from "./svg/more.svg";
import mxChange from "./svg/mxChange.svg";
import newsColor from "./svg/newsColor.svg";
import noCustomizationAvailable from "./svg/noCustomizationAvailable.svg";
import noPostmaster from "./svg/noPostmaster.svg";
import notFound from "./svg/notFound.svg";
import pageNotFound from "./svg/pageNotFpund.svg";
import placeholderIllustration from "./svg/placeholderIllustration.svg";
import planBasic from "./svg/planBasic.svg";
import planEnterprise from "./svg/planEnterprise.svg";
import planProfessional from "./svg/planProfessional.svg";
import plus from "./svg/plus.svg";
import postmasterColor from "./svg/postmasterColor.svg";
import refresh from "./svg/refresh.svg";
import registerColor from "./svg/registerColor.svg";
import reportColor from "./svg/reportColor.svg";
import search from "./svg/search.svg";
import selectLogEtlive from "./svg/selectLogEtlive.svg";
import settings from "./svg/settings.svg";
import settingsColor from "./svg/settingsColor.svg";
import support from "./svg/support.svg";
import supportColor from "./svg/supportColor.svg";
import teamMembers from "./svg/teamMembers.svg";
import teamMembersColor from "./svg/teamMembersColor.svg";
import trash from "./svg/trash.svg";
import upgradeAccounts from "./svg/upgradeAccounts.svg";
import upgradePlan from "./svg/upgradePlan.svg";
import upload from "./svg/upload.svg";
import user from "./svg/user.svg";
import warningFill from "./svg/warningFill.svg";
import warningFillYellow from "./svg/warningFillYellow.svg";
import disabledEtlive from "./svg/disabledEtlive.svg";
import unorderList from "./svg/unorderList.svg";
import unlink from "./svg/unlink.svg";
import underline from "./svg/underline.svg";
import textColor from "./svg/textColor.svg";
import strike from "./svg/strike.svg";
import quoteFill from "./svg/quoteFill.svg";
import outdent from "./svg/outdent.svg";
import orderList from "./svg/orderList.svg";
import link from "./svg/link.svg";
import italic from "./svg/italic.svg";
import indent from "./svg/indent.svg";
import image from "./svg/image.svg";
import html from "./svg/html.svg";
import emoticon from "./svg/emoticon.svg";
import clearFormatting from "./svg/clearFormatting.svg";
import bold from "./svg/bold.svg";
import bgColor from "./svg/bgColor.svg";
import alignCenter from "./svg/alignCenter.svg";
import alignLeft from "./svg/alignLeft.svg";
import alignRight from "./svg/alignRight.svg";
import close from "./svg/close.svg";
import loginXmas from "./svg/login_christmas.svg";
import prices from "./svg/prices.svg";
import stars0 from "./svg/stars0.svg";
import stars1 from "./svg/stars1.svg";
import stars2 from "./svg/stars2.svg";
import stars3 from "./svg/stars3.svg";
import starLocked from "./svg/starLocked.svg";
import star from "./svg/star.svg";
import medal from "./svg/medal.svg";
import restore from "./svg/restore.svg";
import mailbox from "./svg/mailbox.svg";
import emailDelivery from "./svg/emailDelivery.svg";
import emailDeliveryAccessRequest from "./svg/emailDelivery-accessRequest.svg";
import users from "./svg/users.svg";
import suppressionList from "./svg/suppressionList.svg";
import copy from "./svg/copy.svg";
import DeliveryIntro from "./svg/emailDeliveryIntro.svg";
import MailboxIntro from "./svg/mailboxIntro.svg";
import gridLayout from "./svg/grid-interface.svg";
import listLayout from "./svg/list.svg";
import exchangeColor from "./svg/exchangeColor.svg";
import antimalware from "./svg/antimalware.svg";
import sentMsg from "./svg/sentMsg.svg";
import hourglass from "./svg/hourglass.svg";
import delivered from "./svg/delivered.svg";
import warning from "./svg/warning.svg";
import warningCircular from "./svg/warning-circular.svg";
import download from "./svg/download.svg";
import videoColor from "./svg/videoColor.svg";
import vianovaMail from "./svg/loginLogoVianova.svg";
import vianovaLogo from "./svg/vianovaLogo.svg";
import poweredByQboxmail from "./svg/logoPoweredBy.svg";
import eye from "./svg/eye.svg";
import eyeNot from "./svg/eyeNot.svg";

export {
  Icon,
  addArchive,
  addCustomization,
  addDomain,
  addDomainAlias,
  addEmailAccount,
  addEmailAlias,
  addImport,
  addManager,
  addMigration,
  addTeamMember,
  addSuppressionList,
  adminColor,
  aliasMailColor,
  appleStore,
  archive,
  archiveColor,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowSort,
  arrowSortDown,
  arrowSortUp,
  arrowSwapColor,
  arrowUp,
  attach,
  attention,
  back,
  calendar,
  cartColor,
  check,
  check2,
  checkFatFill,
  closeCircle,
  congratulations,
  creationArchive,
  creationDelegate,
  customizationsColor,
  dashboardColor,
  delegate,
  delegateColor,
  disable,
  disabled,
  disabledAccount,
  disabledArchive,
  disabledDomain,
  docs,
  edit,
  enable,
  errorFill,
  etliveColor,
  file,
  flag,
  globe,
  globeColor,
  googlePlayStore,
  help,
  helpFill,
  imports,
  importsColor,
  infoFill,
  less,
  lock,
  loginIllustration,
  logoutColor,
  mail,
  mailColor,
  manager,
  managerColor,
  menu,
  migrations,
  migrationsColor,
  more,
  newsColor,
  noCustomizationAvailable,
  noPostmaster,
  notFound,
  pageNotFound,
  placeholderIllustration,
  planBasic,
  planEnterprise,
  planProfessional,
  plus,
  postmasterColor,
  refresh,
  registerColor,
  reportColor,
  search,
  selectLogEtlive,
  settings,
  settingsColor,
  support,
  supportColor,
  teamMembers,
  teamMembersColor,
  trash,
  upgradeAccounts,
  upgradePlan,
  upload,
  user,
  warningFill,
  warningFillYellow,
  disabledEtlive,
  mxChange,
  unorderList,
  unlink,
  underline,
  textColor,
  strike,
  quoteFill,
  outdent,
  orderList,
  link,
  italic,
  indent,
  image,
  html,
  emoticon,
  clearFormatting,
  bold,
  bgColor,
  alignCenter,
  alignLeft,
  alignRight,
  close,
  loginXmas,
  prices,
  stars0,
  stars1,
  stars2,
  stars3,
  starLocked,
  star,
  medal,
  restore,
  mailbox,
  emailDelivery,
  emailDeliveryAccessRequest,
  users,
  suppressionList,
  copy,
  DeliveryIntro,
  MailboxIntro,
  gridLayout,
  listLayout,
  exchangeColor,
  antimalware,
  sentMsg,
  hourglass,
  delivered,
  warning,
  warningCircular,
  download,
  videoColor,
  vianovaMail,
  vianovaLogo,
  poweredByQboxmail,
  eye,
  eyeNot,
};
